import React, { useState, useEffect } from 'react';
import { FileSearchOutlined, SearchOutlined } from '@ant-design/icons';
import {
    Spin,
    Table,
    Tag,
    Row,
    Col,
    Input,
    Button,
    Popconfirm,
    Avatar,
    List,
} from 'antd';
import moment from 'moment';
import { delay } from '../../helpers/helpers';
import cookies from 'js-cookie';
import axiosConfig from '../../utils/axios-config';
import { useSelector } from 'react-redux';
import './task-history-table.scss';
import { withRouter, useHistory, Link } from 'react-router-dom';

const TaskHistoryTable = () => {
    let history = useHistory();
    const [filteredData, setFilteredData] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchCriteria, setSearchCriteria] = useState({});
    const currentUser = useSelector((state) => state.auth.currentUser);

    useEffect(() => {
        let isMounted = true;
        if (currentUser && currentUser.id && isMounted) {
            fetchTable();
        }
        return () => {
            isMounted = false;
        };
    }, []);

    const fetchTable = async () => {

        try {
            setLoading(true);
            await axiosConfig({
                method: 'get',
                url: `/api/rpa/task-triggers`,
                headers: {
                    Authorization: `Bearer ${cookies.get('access_token')}`,
                },
            })
                .then((response) => {
                    console.log('Table Data', response);
                    const data = response.data.data.map((res, index) => {
                        index++;
                        return {
                            key: res.id,
                            no: res.id,
                            companyName: res.company?.name,
                            departmentName: res.department?.name,
                            taskName: res.taskName,
                            priority: res.priority,
                            wizardCustomId: res.wizardCustomId,
                            variables: res.variables,
                            created: res.created,
                        };
                    });
                    setTableData(data);
                    setFilteredData(data);
                    setLoading(false);
                })
                .catch((error) => {
                    if (error.response) {
                        // The request was made and the server responded with a status code
                        // that falls out of the range of 2xx
                        console.log(error.response.data);
                        console.log(error.response.status);
                        console.log(error.response.headers);
                    } else if (error.request) {
                        // The request was made but no response was received
                        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                        // http.ClientRequest in node.js
                        console.log(error.request);
                    } else {
                        // Something happened in setting up the request that triggered an Error
                        console.log('Error', error.message);
                    }
                    setLoading(false);
                    console.log(error.config);
                })
        }
        catch (error) {

        }
        finally {
            setLoading(false);
        }

    };

    const changePage = (page, settingId) => {
        switch (page) {
            case 'create':
                history.push('/rpa/task-trigger');
                break;
            default:
                break;
        }
    };

    const columns = [
        {
            title: 'Company',
            dataIndex: 'companyName',
            key: 'companyName',
        },
        {
            title: 'Department',
            dataIndex: 'departmentName',
            key: 'departmentName',
        },
        {
            title: 'Task Name',
            dataIndex: 'taskName',
            key: 'taskName',
        },
        {
            title: 'Priority',
            key: 'priority',
            dataIndex: 'priority',
        },
        {
            title: 'Wizard Custom Id',
            key: 'wizardCustomId',
            dataIndex: 'wizardCustomId',
        },
        {
            title: 'Variables',
            key: 'variables',
            dataIndex: 'variables',
            render: (text) => {
                let parsed = [];
                try {
                    parsed = JSON.parse(text);
                } catch (e) {
                    return <span>Invalid JSON</span>;
                }

                return (
                    <div>
                        {parsed.map((item, index) => (
                            <div key={index}>
                                <strong>{item.Name}:</strong> {item.Value}
                            </div>
                        ))}
                    </div>
                );
            }
        },
        {
            title: 'Created Time',
            dataIndex: 'created',
            key: 'created',
            render: (text) => {
                const dateObject = moment(text);
                const formattedDate = dateObject.format("YYYY-MM-DD HH:mm:ss");
                return formattedDate;
            }
        }

    ];

    return (
        <Spin spinning={loading}>
            <Row className='search-area' gutter={{ lg: 8 }}>
                <Col span={8}>
                    <Button onClick={() => changePage('create')} type='primary'>
                        Trigger Task
                    </Button>
                </Col>
            </Row>
            <Table columns={columns} dataSource={filteredData} />
        </Spin>
    );
};

export default TaskHistoryTable;
